import * as React from "react"

export const HeaderWithDescription = (props: { text: string, description?: string } = { text: "" }) => {
    return (
        <div className={"header-with-desc"}>
            <div className={"header brandon-bold"}>{props.text}</div>
            {
                props.description && <div className={"description-text"}>{props.description}</div>
            }
        </div>
    )
}